import React from 'react';
import moment from 'moment';
import Base from "./Base";
import Empty from "./Empty";
import DocumentRequirement from "./DocumentRequirement";
import QuestionRequirement from "./QuestionRequirement";
import DisclaimerRequirement from "./DisclaimerRequirement";
import PaymentRequirement from "./PaymentRequirement";
import ApplicationStatus from "./ApplicationStatus";
import { _ContentContainer, _PlainText, _StatusHeading } from "./style";
export default function TimelineContent(_ref) {
  var row = _ref.row,
    userIsOnMobile = _ref.userIsOnMobile;
  var content;
  switch (row.type) {
    case 'base':
      content = /*#__PURE__*/React.createElement(Base, {
        updatedAt: row.updatedAt,
        acceptedStatus: row.acceptedStatus
      });
      break;
    case 'empty':
      content = /*#__PURE__*/React.createElement(Empty, null);
      break;
    case 'documentRequirement':
    case 'receiptRequirement':
      content = /*#__PURE__*/React.createElement(DocumentRequirement, {
        row: row
      });
      break;
    case 'paymentRequirement':
      content = /*#__PURE__*/React.createElement(PaymentRequirement, {
        row: row
      });
      break;
    case 'questionRequirement':
      content = /*#__PURE__*/React.createElement(QuestionRequirement, {
        row: row,
        userIsOnMobile: userIsOnMobile
      });
      break;
    case 'disclaimerRequirement':
      content = /*#__PURE__*/React.createElement(DisclaimerRequirement, {
        row: row
      });
      break;
    case 'application_status_updated':
    case 'application_self_evaluated':
    case 'applicationStatus':
      content = /*#__PURE__*/React.createElement(ApplicationStatus, {
        row: row
      });
      break;
    case 'self_serve_request':
      content = /*#__PURE__*/React.createElement(SelfServeRequest, {
        row: row
      });
      break;
    default:
      content = /*#__PURE__*/React.createElement("div", null, row.type);
      break;
  }
  return /*#__PURE__*/React.createElement(_ContentContainer, {
    position: row.position
  }, content);
}
function SelfServeRequest(_ref2) {
  var _row$attributes, _row$attributes2, _row$attributes3, _row$attributes4, _row$attributes5, _row$attributes6, _row$attributes7, _row$attributes8, _row$attributes9, _row$attributes10, _row$attributes11, _row$attributes12;
  var row = _ref2.row;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StatusHeading, null, row.status), ((_row$attributes = row.attributes) === null || _row$attributes === void 0 ? void 0 : _row$attributes.request_type) === 'deferral' && /*#__PURE__*/React.createElement(React.Fragment, null, ((_row$attributes2 = row.attributes) === null || _row$attributes2 === void 0 ? void 0 : _row$attributes2.existing_esl_intake) && /*#__PURE__*/React.createElement(_PlainText, null, "Current ESL Intake: ", moment((_row$attributes3 = row.attributes) === null || _row$attributes3 === void 0 ? void 0 : _row$attributes3.existing_esl_intake).format('MMMM YYYY')), ((_row$attributes4 = row.attributes) === null || _row$attributes4 === void 0 ? void 0 : _row$attributes4.requested_esl_intake) && /*#__PURE__*/React.createElement(_PlainText, null, "Requested ESL Intake:", ' ', moment((_row$attributes5 = row.attributes) === null || _row$attributes5 === void 0 ? void 0 : _row$attributes5.requested_esl_intake).format('MMMM YYYY')), ((_row$attributes6 = row.attributes) === null || _row$attributes6 === void 0 ? void 0 : _row$attributes6.existing_main_intake) && /*#__PURE__*/React.createElement(_PlainText, null, "Current Academic Intake:", ' ', moment((_row$attributes7 = row.attributes) === null || _row$attributes7 === void 0 ? void 0 : _row$attributes7.existing_main_intake).format('MMMM YYYY')), ((_row$attributes8 = row.attributes) === null || _row$attributes8 === void 0 ? void 0 : _row$attributes8.requested_main_intake) && /*#__PURE__*/React.createElement(_PlainText, null, "Requested Academic Intake:", ' ', moment((_row$attributes9 = row.attributes) === null || _row$attributes9 === void 0 ? void 0 : _row$attributes9.requested_main_intake).format('MMMM YYYY')), /*#__PURE__*/React.createElement(_PlainText, null, "Visa Status: ", getVisaStatus((_row$attributes10 = row.attributes) === null || _row$attributes10 === void 0 ? void 0 : _row$attributes10.visa_status)), /*#__PURE__*/React.createElement(_PlainText, null, "Deferral Reason: ", (_row$attributes11 = row.attributes) === null || _row$attributes11 === void 0 ? void 0 : _row$attributes11.request_reason_detail)), ((_row$attributes12 = row.attributes) === null || _row$attributes12 === void 0 ? void 0 : _row$attributes12.request_type) === 'tuition_deposit_refund' && /*#__PURE__*/React.createElement(_PlainText, null, "Refund Reason: ", row.attributes.request_reason_detail));
}
function getVisaStatus(status) {
  switch (status) {
    case 'approved':
      return 'Visa Approved';
    case 'not_submitted':
      return 'Visa Not Submitted';
    case 'pending':
      return 'Visa Pending';
    case 'refused':
      return 'Visa Refused';
    default:
      return 'N/A';
  }
}